module.exports = __webpack_public_path__ + "img/violet_048.6e922f54.png";